<template>
  <div class="filtro-autos">
    <v-form name="myform">
      <v-card class="mb-10">
        <v-card-title class="subtitle-1">Filtros</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="2" sm="12">
              <v-text-field
                dense
                type="date"
                label="Data Infração (Início)"
                v-model="filtro.data_inicial"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="12">
              <v-text-field
                dense
                type="date"
                label="Data Infração (Fim)"
                v-model="filtro.data_final"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" type="submit" @click.prevent="input(filtro)"
            >Pesquisar</v-btn
          >
          <v-btn
            color="primary"
            outlined
            class="ml-5"
            @click.prevent="resetFiltro"
            >Limpar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
export default {
  name: "FiltroMultas",
  data() {
    return {
      multas: [],
      filtro: {},
    };
  },
  methods: {
    input(filtro) {
      this.$emit("input", filtro);
    },
    resetFiltro() {
      this.filtro = {};
    },
  },
};
</script>
